// One native rotation clip per selected product; keyboard range replaces player chrome.
(() => {
  // One pace for gallery clips and cards, including cards added by filters or recommendations.
  const slowRotation = event => {
    const video = event.target;
    if (video.matches?.('[data-lx-card-video], [data-lx-rotation] video')) {
      video.defaultPlaybackRate = .25;
      video.playbackRate = .25;
    }
  };
  document.addEventListener('loadedmetadata', slowRotation, true);
  document.addEventListener('play', slowRotation, true);
  function init() {
    document.querySelectorAll('[data-lx-rotation]').forEach(root => {
      const video = root.querySelector('video'), range = root.querySelector('[data-lx-angle]'), toggle = root.querySelector('[data-lx-toggle]');
      if (!video || !range || !toggle || root.dataset.lxReady) return;
      root.dataset.lxReady = 'true';
      slowRotation({target:video});
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = reduce.matches, visible = false, drag = null;
      const ready = () => Number.isFinite(video.duration) && video.duration > 0;
      const seek = ratio => { if (ready()) video.currentTime = Math.max(0, Math.min(.9999, ratio)) * video.duration; };
      const state = () => { toggle.textContent = video.paused ? 'Resume rotation' : 'Pause rotation'; toggle.setAttribute('aria-pressed', String(!video.paused)); };
      const play = () => { if (!video.hidden && !document.hidden && visible && !userPaused) video.play().catch(state); };
      video.muted = true;
      video.addEventListener('play', state); video.addEventListener('pause', state);
      video.addEventListener('timeupdate', () => { if (ready() && !drag) range.value = Math.round(video.currentTime / video.duration * 1000); });
      video.addEventListener('loadedmetadata', () => { range.disabled = false; play(); });
      video.addEventListener('error', () => { range.disabled = true; toggle.disabled = true; const note=root.querySelector('[data-lx-status]'); if(note)note.textContent='Rotation is unavailable. The product photos and specifications remain available.'; });
      video.addEventListener('lx:show', () => { userPaused=reduce.matches; play(); });
      toggle.addEventListener('click', () => { userPaused = !video.paused; if (video.paused) video.play().catch(state); else video.pause(); });
      range.addEventListener('input', () => { userPaused = true; video.pause(); seek(Number(range.value) / 1000); });
      video.addEventListener('pointerdown', e => { drag = {x:e.clientX,y:e.clientY,time:video.currentTime,active:false}; });
      video.addEventListener('pointermove', e => {
        if (!drag || !ready()) return;
        const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
        if (!drag.active && Math.abs(dx)>6 && Math.abs(dx)>Math.abs(dy)) { drag.active=true; userPaused=true; video.pause(); video.setPointerCapture(e.pointerId); }
        if(drag.active){seek(drag.time/video.duration+dx/video.clientWidth);range.value=Math.round(video.currentTime/video.duration*1000);}
      });
      ['pointerup','pointercancel'].forEach(name=>video.addEventListener(name,()=>{drag=null;state();}));
      new IntersectionObserver(entries => { visible=entries[0].isIntersecting; if(visible)play();else video.pause(); },{threshold:.2}).observe(video);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else play();});
      reduce.addEventListener('change',()=>{userPaused=reduce.matches;if(userPaused)video.pause();else play();});
      range.disabled=!ready(); state();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();